import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminNotetemplates: build.query<
      GetV2AdminNotetemplatesApiResponse,
      GetV2AdminNotetemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates`,
        params: {
          scope: queryArg.scope,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    postV2AdminNotetemplatesApplyFeedback: build.mutation<
      PostV2AdminNotetemplatesApplyFeedbackApiResponse,
      PostV2AdminNotetemplatesApplyFeedbackApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/apply-feedback`,
        method: "POST",
        body: queryArg.applyFeedbackToTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesBuildFromTemplate: build.mutation<
      PostV2AdminNotetemplatesBuildFromTemplateApiResponse,
      PostV2AdminNotetemplatesBuildFromTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/build/from-template`,
        method: "POST",
        body: queryArg.adminTemplateBuildFromTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesBuildByTaskIdSave: build.mutation<
      PostV2AdminNotetemplatesBuildByTaskIdSaveApiResponse,
      PostV2AdminNotetemplatesBuildByTaskIdSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/build/${queryArg.taskId}/save`,
        method: "POST",
      }),
    }),
    getV2AdminNotetemplatesBuildByTaskIdStatus: build.query<
      GetV2AdminNotetemplatesBuildByTaskIdStatusApiResponse,
      GetV2AdminNotetemplatesBuildByTaskIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/build/${queryArg.taskId}/status`,
      }),
    }),
    postV2AdminNotetemplatesConvertToOrg: build.mutation<
      PostV2AdminNotetemplatesConvertToOrgApiResponse,
      PostV2AdminNotetemplatesConvertToOrgApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/convert-to-org`,
        method: "POST",
        body: queryArg.adminConvertToOrgRequest,
      }),
    }),
    postV2AdminNotetemplatesCopy: build.mutation<
      PostV2AdminNotetemplatesCopyApiResponse,
      PostV2AdminNotetemplatesCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/copy`,
        method: "POST",
        body: queryArg.adminCopyNoteTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesForkForUser: build.mutation<
      PostV2AdminNotetemplatesForkForUserApiResponse,
      PostV2AdminNotetemplatesForkForUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/fork-for-user`,
        method: "POST",
        body: queryArg.adminForkTemplateForUserRequest,
      }),
    }),
    postV2AdminNotetemplatesModelConversionCopyToNew: build.mutation<
      PostV2AdminNotetemplatesModelConversionCopyToNewApiResponse,
      PostV2AdminNotetemplatesModelConversionCopyToNewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/copy-to-new`,
        method: "POST",
        body: queryArg.copyToNewTemplateRequest,
      }),
    }),
    postV2AdminNotetemplatesModelConversionSave: build.mutation<
      PostV2AdminNotetemplatesModelConversionSaveApiResponse,
      PostV2AdminNotetemplatesModelConversionSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/save`,
        method: "POST",
        body: queryArg.saveConvertedRevisionRequest,
      }),
    }),
    postV2AdminNotetemplatesModelConversionStart: build.mutation<
      PostV2AdminNotetemplatesModelConversionStartApiResponse,
      PostV2AdminNotetemplatesModelConversionStartApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/start`,
        method: "POST",
        body: queryArg.startModelConversionRequest,
      }),
    }),
    getV2AdminNotetemplatesModelConversionStatusByThreadId: build.query<
      GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiResponse,
      GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/model-conversion/status/${queryArg.threadId}`,
      }),
    }),
    getV2AdminNotetemplatesOrgByOrganizationId: build.query<
      GetV2AdminNotetemplatesOrgByOrganizationIdApiResponse,
      GetV2AdminNotetemplatesOrgByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/org/${queryArg.organizationId}`,
      }),
    }),
    postV2AdminNotetemplatesOrgByOrganizationId: build.mutation<
      PostV2AdminNotetemplatesOrgByOrganizationIdApiResponse,
      PostV2AdminNotetemplatesOrgByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/org/${queryArg.organizationId}`,
        method: "POST",
        body: queryArg.adminCreateOrgTemplateRequest,
      }),
    }),
    getV2AdminNotetemplatesProviderByProviderId: build.query<
      GetV2AdminNotetemplatesProviderByProviderIdApiResponse,
      GetV2AdminNotetemplatesProviderByProviderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/provider/${queryArg.providerId}`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminNotetemplatesUserByUserId: build.query<
      GetV2AdminNotetemplatesUserByUserIdApiResponse,
      GetV2AdminNotetemplatesUserByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/user/${queryArg.userId}`,
      }),
    }),
    deleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateId:
      build.mutation<
        DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiResponse,
        DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/notetemplates/user/${queryArg.userId}/templates/${queryArg.templateId}`,
          method: "DELETE",
        }),
      }),
    deleteV2AdminNotetemplatesByTemplateId: build.mutation<
      DeleteV2AdminNotetemplatesByTemplateIdApiResponse,
      DeleteV2AdminNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminNotetemplatesByTemplateId: build.query<
      GetV2AdminNotetemplatesByTemplateIdApiResponse,
      GetV2AdminNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}`,
      }),
    }),
    putV2AdminNotetemplatesByTemplateId: build.mutation<
      PutV2AdminNotetemplatesByTemplateIdApiResponse,
      PutV2AdminNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}`,
        method: "PUT",
        body: queryArg.adminUpdateNoteTemplateRequest,
      }),
    }),
    getV2AdminNotetemplatesByTemplateIdRevisions: build.query<
      GetV2AdminNotetemplatesByTemplateIdRevisionsApiResponse,
      GetV2AdminNotetemplatesByTemplateIdRevisionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}/revisions`,
      }),
    }),
    getV2AdminNotetemplatesByTemplateIdRevisionsAndVersion: build.query<
      GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiResponse,
      GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notetemplates/${queryArg.templateId}/revisions/${queryArg.version}`,
      }),
    }),
    getV2AdminTemplatesAsyncTaskStatus: build.query<
      GetV2AdminTemplatesAsyncTaskStatusApiResponse,
      GetV2AdminTemplatesAsyncTaskStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/async-task-status`,
        params: {
          async_task_id: queryArg.asyncTaskId,
        },
      }),
    }),
    postV2AdminTemplatesConvert: build.mutation<
      PostV2AdminTemplatesConvertApiResponse,
      PostV2AdminTemplatesConvertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/convert`,
        method: "POST",
        body: queryArg.convertLegacyTemplateRequest,
      }),
    }),
    postV2AdminTemplatesCopy: build.mutation<
      PostV2AdminTemplatesCopyApiResponse,
      PostV2AdminTemplatesCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/copy`,
        method: "POST",
        body: queryArg.copyTemplatesRequest,
      }),
    }),
    postV2AdminTemplatesSingleModuleGeneration: build.mutation<
      PostV2AdminTemplatesSingleModuleGenerationApiResponse,
      PostV2AdminTemplatesSingleModuleGenerationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/single-module-generation`,
        method: "POST",
        body: queryArg.singleModuleGenerationRequest,
      }),
    }),
    getV2AdminTemplatesUserTemplates: build.query<
      GetV2AdminTemplatesUserTemplatesApiResponse,
      GetV2AdminTemplatesUserTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/templates/user-templates`,
        params: {
          user_id: queryArg.userId,
          search_query: queryArg.searchQuery,
        },
      }),
    }),
    getV2ProviderNotetemplates: build.query<
      GetV2ProviderNotetemplatesApiResponse,
      GetV2ProviderNotetemplatesApiArg
    >({
      query: () => ({ url: `/v2/provider/notetemplates` }),
    }),
    postV2ProviderNotetemplates: build.mutation<
      PostV2ProviderNotetemplatesApiResponse,
      PostV2ProviderNotetemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates`,
        method: "POST",
        body: queryArg.createNoteTemplateRequest,
      }),
    }),
    postV2ProviderNotetemplatesBuild: build.mutation<
      PostV2ProviderNotetemplatesBuildApiResponse,
      PostV2ProviderNotetemplatesBuildApiArg
    >({
      query: () => ({
        url: `/v2/provider/notetemplates/build`,
        method: "POST",
      }),
    }),
    postV2ProviderNotetemplatesBuildFromTemplate: build.mutation<
      PostV2ProviderNotetemplatesBuildFromTemplateApiResponse,
      PostV2ProviderNotetemplatesBuildFromTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/build/from-template`,
        method: "POST",
        body: queryArg.templateBuildFromTemplateRequest,
      }),
    }),
    postV2ProviderNotetemplatesBuildByTaskIdConfirm: build.mutation<
      PostV2ProviderNotetemplatesBuildByTaskIdConfirmApiResponse,
      PostV2ProviderNotetemplatesBuildByTaskIdConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/build/${queryArg.taskId}/confirm`,
        method: "POST",
        body: queryArg.templateBuildConfirmRequest,
      }),
    }),
    postV2ProviderNotetemplatesBuildByTaskIdSave: build.mutation<
      PostV2ProviderNotetemplatesBuildByTaskIdSaveApiResponse,
      PostV2ProviderNotetemplatesBuildByTaskIdSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/build/${queryArg.taskId}/save`,
        method: "POST",
      }),
    }),
    getV2ProviderNotetemplatesBuildByTaskIdStatus: build.query<
      GetV2ProviderNotetemplatesBuildByTaskIdStatusApiResponse,
      GetV2ProviderNotetemplatesBuildByTaskIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/build/${queryArg.taskId}/status`,
      }),
    }),
    getV2ProviderNotetemplatesLibrary: build.query<
      GetV2ProviderNotetemplatesLibraryApiResponse,
      GetV2ProviderNotetemplatesLibraryApiArg
    >({
      query: () => ({ url: `/v2/provider/notetemplates/library` }),
    }),
    getV2ProviderNotetemplatesOrganization: build.query<
      GetV2ProviderNotetemplatesOrganizationApiResponse,
      GetV2ProviderNotetemplatesOrganizationApiArg
    >({
      query: () => ({ url: `/v2/provider/notetemplates/organization` }),
    }),
    postV2ProviderNotetemplatesOrganization: build.mutation<
      PostV2ProviderNotetemplatesOrganizationApiResponse,
      PostV2ProviderNotetemplatesOrganizationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/organization`,
        method: "POST",
        body: queryArg.createOrgNoteTemplateRequest,
      }),
    }),
    postV2ProviderNotetemplatesOrganizationConvert: build.mutation<
      PostV2ProviderNotetemplatesOrganizationConvertApiResponse,
      PostV2ProviderNotetemplatesOrganizationConvertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/organization/convert`,
        method: "POST",
        body: queryArg.convertToOrgTemplateRequest,
      }),
    }),
    patchV2ProviderNotetemplatesReorder: build.mutation<
      PatchV2ProviderNotetemplatesReorderApiResponse,
      PatchV2ProviderNotetemplatesReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/reorder`,
        method: "PATCH",
        body: queryArg.reorderTemplatesRequest,
      }),
    }),
    deleteV2ProviderNotetemplatesByTemplateId: build.mutation<
      DeleteV2ProviderNotetemplatesByTemplateIdApiResponse,
      DeleteV2ProviderNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderNotetemplatesByTemplateId: build.query<
      GetV2ProviderNotetemplatesByTemplateIdApiResponse,
      GetV2ProviderNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}`,
      }),
    }),
    putV2ProviderNotetemplatesByTemplateId: build.mutation<
      PutV2ProviderNotetemplatesByTemplateIdApiResponse,
      PutV2ProviderNotetemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}`,
        method: "PUT",
        body: queryArg.updateNoteTemplateRequest,
      }),
    }),
    postV2ProviderNotetemplatesByTemplateIdAdd: build.mutation<
      PostV2ProviderNotetemplatesByTemplateIdAddApiResponse,
      PostV2ProviderNotetemplatesByTemplateIdAddApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}/add`,
        method: "POST",
      }),
    }),
    postV2ProviderNotetemplatesByTemplateIdFork: build.mutation<
      PostV2ProviderNotetemplatesByTemplateIdForkApiResponse,
      PostV2ProviderNotetemplatesByTemplateIdForkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}/fork`,
        method: "POST",
      }),
    }),
    deleteV2ProviderNotetemplatesByTemplateIdRemove: build.mutation<
      DeleteV2ProviderNotetemplatesByTemplateIdRemoveApiResponse,
      DeleteV2ProviderNotetemplatesByTemplateIdRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}/remove`,
        method: "DELETE",
      }),
    }),
    putV2ProviderNotetemplatesByTemplateIdSectionsAndSectionId: build.mutation<
      PutV2ProviderNotetemplatesByTemplateIdSectionsAndSectionIdApiResponse,
      PutV2ProviderNotetemplatesByTemplateIdSectionsAndSectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notetemplates/${queryArg.templateId}/sections/${queryArg.sectionId}`,
        method: "PUT",
        body: queryArg.updateSectionContentRequest,
      }),
    }),
    getV2ProviderSectionsLibrary: build.query<
      GetV2ProviderSectionsLibraryApiResponse,
      GetV2ProviderSectionsLibraryApiArg
    >({
      query: () => ({ url: `/v2/provider/sections/library` }),
    }),
    postV2ProviderSectionsLibrarySearch: build.mutation<
      PostV2ProviderSectionsLibrarySearchApiResponse,
      PostV2ProviderSectionsLibrarySearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/sections/library/search`,
        method: "POST",
        body: queryArg.searchSectionsRequest,
      }),
    }),
    getV2ProviderSectionsLibraryBySectionId: build.query<
      GetV2ProviderSectionsLibraryBySectionIdApiResponse,
      GetV2ProviderSectionsLibraryBySectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/sections/library/${queryArg.sectionId}`,
      }),
    }),
    postV2ProviderSectionsLibraryBySectionIdFork: build.mutation<
      PostV2ProviderSectionsLibraryBySectionIdForkApiResponse,
      PostV2ProviderSectionsLibraryBySectionIdForkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/sections/library/${queryArg.sectionId}/fork`,
        method: "POST",
        body: queryArg.forkSectionRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminNotetemplatesApiResponse =
  /** status 200 OK */ AdminNoteTemplateListResponse;
export type GetV2AdminNotetemplatesApiArg = {
  /** Filter by scope: public, org, or user */
  scope?: string | null;
  /** Max results to return */
  limit?: number;
  /** Pagination offset */
  offset?: number;
};
export type PostV2AdminNotetemplatesApplyFeedbackApiResponse =
  /** status 200 OK */ ApplyFeedbackToTemplateResponse;
export type PostV2AdminNotetemplatesApplyFeedbackApiArg = {
  applyFeedbackToTemplateRequest: ApplyFeedbackToTemplateRequest;
};
export type PostV2AdminNotetemplatesBuildFromTemplateApiResponse =
  /** status 200 OK */ AdminTemplateBuildUploadResponse;
export type PostV2AdminNotetemplatesBuildFromTemplateApiArg = {
  adminTemplateBuildFromTemplateRequest: AdminTemplateBuildFromTemplateRequest;
};
export type PostV2AdminNotetemplatesBuildByTaskIdSaveApiResponse =
  /** status 200 OK */ AdminTemplateBuildSaveResponse;
export type PostV2AdminNotetemplatesBuildByTaskIdSaveApiArg = {
  taskId: string;
};
export type GetV2AdminNotetemplatesBuildByTaskIdStatusApiResponse =
  /** status 200 OK */ AdminTemplateBuildStatusResponse;
export type GetV2AdminNotetemplatesBuildByTaskIdStatusApiArg = {
  taskId: string;
};
export type PostV2AdminNotetemplatesConvertToOrgApiResponse =
  /** status 200 OK */ AdminCopyNoteTemplateResponse;
export type PostV2AdminNotetemplatesConvertToOrgApiArg = {
  adminConvertToOrgRequest: AdminConvertToOrgRequest;
};
export type PostV2AdminNotetemplatesCopyApiResponse =
  /** status 200 OK */ AdminCopyNoteTemplateResponse;
export type PostV2AdminNotetemplatesCopyApiArg = {
  adminCopyNoteTemplateRequest: AdminCopyNoteTemplateRequest;
};
export type PostV2AdminNotetemplatesForkForUserApiResponse =
  /** status 200 OK */ AdminForkTemplateForUserResponse;
export type PostV2AdminNotetemplatesForkForUserApiArg = {
  adminForkTemplateForUserRequest: AdminForkTemplateForUserRequest;
};
export type PostV2AdminNotetemplatesModelConversionCopyToNewApiResponse =
  /** status 200 OK */ CopyToNewTemplateResponse;
export type PostV2AdminNotetemplatesModelConversionCopyToNewApiArg = {
  copyToNewTemplateRequest: CopyToNewTemplateRequest;
};
export type PostV2AdminNotetemplatesModelConversionSaveApiResponse =
  /** status 200 OK */ SaveConvertedRevisionResponse;
export type PostV2AdminNotetemplatesModelConversionSaveApiArg = {
  saveConvertedRevisionRequest: SaveConvertedRevisionRequest;
};
export type PostV2AdminNotetemplatesModelConversionStartApiResponse =
  /** status 200 OK */ StartModelConversionResponse;
export type PostV2AdminNotetemplatesModelConversionStartApiArg = {
  startModelConversionRequest: StartModelConversionRequest;
};
export type GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiResponse =
  /** status 200 OK */ ModelConversionStatusResponse;
export type GetV2AdminNotetemplatesModelConversionStatusByThreadIdApiArg = {
  threadId: string;
};
export type GetV2AdminNotetemplatesOrgByOrganizationIdApiResponse =
  /** status 200 OK */ AdminNoteTemplateListResponse;
export type GetV2AdminNotetemplatesOrgByOrganizationIdApiArg = {
  organizationId: string;
};
export type PostV2AdminNotetemplatesOrgByOrganizationIdApiResponse =
  /** status 200 OK */ AdminCopyNoteTemplateResponse;
export type PostV2AdminNotetemplatesOrgByOrganizationIdApiArg = {
  organizationId: string;
  adminCreateOrgTemplateRequest: AdminCreateOrgTemplateRequest;
};
export type GetV2AdminNotetemplatesProviderByProviderIdApiResponse =
  /** status 200 OK */ AdminProviderTemplateListResponse;
export type GetV2AdminNotetemplatesProviderByProviderIdApiArg = {
  providerId: string;
  /** Organization ID of the provider */
  organizationId: string;
};
export type GetV2AdminNotetemplatesUserByUserIdApiResponse =
  /** status 200 OK */ AdminNoteTemplateListResponse;
export type GetV2AdminNotetemplatesUserByUserIdApiArg = {
  userId: string;
};
export type DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ AdminDeleteTemplateResponse;
export type DeleteV2AdminNotetemplatesUserByUserIdTemplatesAndTemplateIdApiArg =
  {
    userId: string;
    templateId: string;
  };
export type DeleteV2AdminNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ AdminDeleteTemplateResponse;
export type DeleteV2AdminNotetemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type GetV2AdminNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ AdminGetNoteTemplateResponse;
export type GetV2AdminNotetemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type PutV2AdminNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ AdminUpdateNoteTemplateResponse;
export type PutV2AdminNotetemplatesByTemplateIdApiArg = {
  templateId: string;
  adminUpdateNoteTemplateRequest: AdminUpdateNoteTemplateRequest;
};
export type GetV2AdminNotetemplatesByTemplateIdRevisionsApiResponse =
  /** status 200 OK */ AdminListRevisionsResponse;
export type GetV2AdminNotetemplatesByTemplateIdRevisionsApiArg = {
  templateId: string;
};
export type GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiResponse =
  /** status 200 OK */ AdminGetRevisionResponse;
export type GetV2AdminNotetemplatesByTemplateIdRevisionsAndVersionApiArg = {
  templateId: string;
  version: number;
};
export type GetV2AdminTemplatesAsyncTaskStatusApiResponse =
  /** status 200 OK */ AsyncTaskStatusResponse;
export type GetV2AdminTemplatesAsyncTaskStatusApiArg = {
  /** Async task ID to check status for */
  asyncTaskId: string;
};
export type PostV2AdminTemplatesConvertApiResponse =
  /** status 200 OK */ ConvertLegacyTemplateResponse;
export type PostV2AdminTemplatesConvertApiArg = {
  convertLegacyTemplateRequest: ConvertLegacyTemplateRequest;
};
export type PostV2AdminTemplatesCopyApiResponse =
  /** status 200 OK */ CopyTemplatesResponse;
export type PostV2AdminTemplatesCopyApiArg = {
  copyTemplatesRequest: CopyTemplatesRequest;
};
export type PostV2AdminTemplatesSingleModuleGenerationApiResponse =
  /** status 200 OK */ SingleModuleGenerationResponse;
export type PostV2AdminTemplatesSingleModuleGenerationApiArg = {
  singleModuleGenerationRequest: SingleModuleGenerationRequest;
};
export type GetV2AdminTemplatesUserTemplatesApiResponse =
  /** status 200 OK */ UserTemplateListResponse;
export type GetV2AdminTemplatesUserTemplatesApiArg = {
  /** Filter templates by specific user/provider ID */
  userId?: string | null;
  /** Search templates by name or content */
  searchQuery?: string | null;
};
export type GetV2ProviderNotetemplatesApiResponse =
  /** status 200 OK */ NoteTemplateListResponse;
export type GetV2ProviderNotetemplatesApiArg = void;
export type PostV2ProviderNotetemplatesApiResponse =
  /** status 200 OK */ EffectiveNoteTemplateResponse;
export type PostV2ProviderNotetemplatesApiArg = {
  createNoteTemplateRequest: CreateNoteTemplateRequest;
};
export type PostV2ProviderNotetemplatesBuildApiResponse =
  /** status 200 OK */ TemplateBuildUploadResponse;
export type PostV2ProviderNotetemplatesBuildApiArg = void;
export type PostV2ProviderNotetemplatesBuildFromTemplateApiResponse =
  /** status 200 OK */ TemplateBuildUploadResponse;
export type PostV2ProviderNotetemplatesBuildFromTemplateApiArg = {
  templateBuildFromTemplateRequest: TemplateBuildFromTemplateRequest;
};
export type PostV2ProviderNotetemplatesBuildByTaskIdConfirmApiResponse =
  /** status 200 OK */ TemplateBuildStatusResponse;
export type PostV2ProviderNotetemplatesBuildByTaskIdConfirmApiArg = {
  taskId: string;
  templateBuildConfirmRequest: TemplateBuildConfirmRequest;
};
export type PostV2ProviderNotetemplatesBuildByTaskIdSaveApiResponse =
  /** status 200 OK */ TemplateBuildSaveResponse;
export type PostV2ProviderNotetemplatesBuildByTaskIdSaveApiArg = {
  taskId: string;
};
export type GetV2ProviderNotetemplatesBuildByTaskIdStatusApiResponse =
  /** status 200 OK */ TemplateBuildStatusResponse;
export type GetV2ProviderNotetemplatesBuildByTaskIdStatusApiArg = {
  taskId: string;
};
export type GetV2ProviderNotetemplatesLibraryApiResponse =
  /** status 200 OK */ NoteTemplateListResponse;
export type GetV2ProviderNotetemplatesLibraryApiArg = void;
export type GetV2ProviderNotetemplatesOrganizationApiResponse =
  /** status 200 OK */ OrgNoteTemplateListResponse;
export type GetV2ProviderNotetemplatesOrganizationApiArg = void;
export type PostV2ProviderNotetemplatesOrganizationApiResponse =
  /** status 200 OK */ EffectiveNoteTemplateResponse;
export type PostV2ProviderNotetemplatesOrganizationApiArg = {
  createOrgNoteTemplateRequest: CreateOrgNoteTemplateRequest;
};
export type PostV2ProviderNotetemplatesOrganizationConvertApiResponse =
  /** status 200 OK */ EffectiveNoteTemplateResponse;
export type PostV2ProviderNotetemplatesOrganizationConvertApiArg = {
  convertToOrgTemplateRequest: ConvertToOrgTemplateRequest;
};
export type PatchV2ProviderNotetemplatesReorderApiResponse = unknown;
export type PatchV2ProviderNotetemplatesReorderApiArg = {
  reorderTemplatesRequest: ReorderTemplatesRequest;
};
export type DeleteV2ProviderNotetemplatesByTemplateIdApiResponse = unknown;
export type DeleteV2ProviderNotetemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type GetV2ProviderNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ EffectiveNoteTemplateResponse;
export type GetV2ProviderNotetemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type PutV2ProviderNotetemplatesByTemplateIdApiResponse =
  /** status 200 OK */ EffectiveNoteTemplateResponse;
export type PutV2ProviderNotetemplatesByTemplateIdApiArg = {
  templateId: string;
  updateNoteTemplateRequest: UpdateNoteTemplateRequest;
};
export type PostV2ProviderNotetemplatesByTemplateIdAddApiResponse = unknown;
export type PostV2ProviderNotetemplatesByTemplateIdAddApiArg = {
  templateId: string;
};
export type PostV2ProviderNotetemplatesByTemplateIdForkApiResponse =
  /** status 200 OK */ EffectiveNoteTemplateResponse;
export type PostV2ProviderNotetemplatesByTemplateIdForkApiArg = {
  templateId: string;
};
export type DeleteV2ProviderNotetemplatesByTemplateIdRemoveApiResponse =
  unknown;
export type DeleteV2ProviderNotetemplatesByTemplateIdRemoveApiArg = {
  templateId: string;
};
export type PutV2ProviderNotetemplatesByTemplateIdSectionsAndSectionIdApiResponse =
  unknown;
export type PutV2ProviderNotetemplatesByTemplateIdSectionsAndSectionIdApiArg = {
  templateId: string;
  sectionId: string;
  updateSectionContentRequest: UpdateSectionContentRequest;
};
export type GetV2ProviderSectionsLibraryApiResponse =
  /** status 200 OK */ SectionLibraryListResponse;
export type GetV2ProviderSectionsLibraryApiArg = void;
export type PostV2ProviderSectionsLibrarySearchApiResponse =
  /** status 200 OK */ SectionLibraryListResponse;
export type PostV2ProviderSectionsLibrarySearchApiArg = {
  searchSectionsRequest: SearchSectionsRequest;
};
export type GetV2ProviderSectionsLibraryBySectionIdApiResponse =
  /** status 200 OK */ SectionLibraryResponse2;
export type GetV2ProviderSectionsLibraryBySectionIdApiArg = {
  sectionId: string;
};
export type PostV2ProviderSectionsLibraryBySectionIdForkApiResponse =
  /** status 201 Created */ SectionLibraryResponse2;
export type PostV2ProviderSectionsLibraryBySectionIdForkApiArg = {
  sectionId: string;
  forkSectionRequest: ForkSectionRequest;
};
export type AdminNoteTemplateInfo = {
  /** Whether users can fork this */
  allow_user_forks: boolean;
  /** Creation timestamp */
  created_at?: string | null;
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Template UUID */
  id: string;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** User ID who owns the template */
  user_id: string;
};
export type AdminNoteTemplateListResponse = {
  /** List of templates */
  templates?: AdminNoteTemplateInfo[];
  /** Total number of templates */
  total_count?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ApplyFeedbackToTemplateResponse = {
  /** Status of the workflow task */
  status: string;
  /** Task ID for the async workflow */
  task_id: string;
  /** Thread ID for workflow state management */
  thread_id: string;
  /** Name of the workflow */
  workflow_name: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ApplyFeedbackToTemplateRequest = {
  /** Organization ID of the user */
  organization_id?: string | null;
  /** ID of the template to modify */
  template_id: string;
  /** User feedback text describing desired changes */
  text: string;
  /** User ID making the request */
  user_id: string;
  /** Version number to use (defaults to latest) */
  version?: number | null;
};
export type AdminTemplateBuildUploadResponse = {
  /** Draft template data (included for from-template) */
  draft_template?: {
    [key: string]: any;
  } | null;
  /** Source template ID when editing existing */
  source_template_id?: string | null;
  /** Status: pending, generating_examples, ready_for_review */
  status: string;
  /** User who owns this task */
  target_user_id: string;
  /** Unique task ID */
  task_id: string;
  /** Workflow thread ID */
  thread_id: string;
};
export type AdminTemplateBuildFromTemplateRequest = {
  /** Organization ID for the target user */
  target_organization_id: string;
  /** User ID who will own the task and resulting template */
  target_user_id: string;
  /** ID of the existing template to load for editing */
  template_id: string;
};
export type AdminTemplateBuildSaveResponse = {
  /** Completion status */
  status?: string;
  /** User who owns the template */
  target_user_id: string;
  /** Task ID */
  task_id: string;
  /** Created/updated template ID */
  template_id: string;
};
export type AdminTemplateBuildStatusResponse = {
  /** Created template ID when completed */
  created_template_id?: string | null;
  /** Document summary (for PDFs) */
  document_summary?: string | null;
  /** Document title (for PDFs) */
  document_title?: string | null;
  /** Draft template data */
  draft_template?: {
    [key: string]: any;
  } | null;
  /** Error message if failed */
  error?: string | null;
  /** Progress message */
  progress_message?: string | null;
  /** Source template ID when editing existing */
  source_template_id?: string | null;
  /** Status: pending, processing, structure_ready, generating_examples, ready_for_review, completed, failed */
  status: string;
  /** User who owns this task */
  target_user_id: string;
  /** Unique task ID */
  task_id: string;
};
export type ExtractionPrompts = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope = "public" | "org" | "user";
export type NoteTemplate = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminCopyNoteTemplateResponse = {
  message?: string;
  revision: NoteTemplateRevision;
  template: NoteTemplate;
};
export type AdminConvertToOrgRequest = {
  /** Organization ID to convert the template to */
  organization_id: string;
  /** Template UUID to convert */
  template_id: string;
};
export type AdminCopyNoteTemplateRequest = {
  /** Organization ID for the new template */
  target_organization_id?: string | null;
  /** User ID to copy the template to */
  target_user_id: string;
  /** Template UUID to copy */
  template_id: string;
};
export type ExtractionPrompts2 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection2 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts2 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision2 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection2[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope2 = "public" | "org" | "user";
export type NoteTemplate2 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope2;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminForkTemplateForUserResponse = {
  /** True if user already had a fork (returned existing) */
  already_existed?: boolean;
  message?: string;
  revision: NoteTemplateRevision2;
  template: NoteTemplate2;
};
export type AdminForkTemplateForUserRequest = {
  /** If true, bypass allow_user_forks check (admin override) */
  bypass_fork_restriction?: boolean;
  /** Template UUID to fork from */
  source_template_id: string;
  /** Organization ID for the user's fork */
  target_organization_id: string;
  /** User ID to create the fork for */
  target_user_id: string;
};
export type CopyToNewTemplateResponse = {
  /** Human-readable result message */
  message: string;
  /** UUID of the newly created template */
  new_template_id: string;
  /** Owner scope of new template */
  owner_scope: string;
  /** UUID of the source template */
  source_template_id: string;
  /** Whether the copy was successful */
  success: boolean;
};
export type CopyToNewTemplateRequest = {
  /** Template content */
  content?: string;
  /** Description for the new template */
  description?: string | null;
  /** Template metadata */
  metadata?: {
    [key: string]: any;
  };
  /** List of model IDs */
  models?: any[];
  /** Owner scope: 'user' or 'organization' */
  owner_scope?: string;
  /** List of section objects with converted prompts */
  sections: any[];
  /** Source template UUID being converted */
  source_template_id: string;
  /** Organization ID for the new template. If not provided, looked up from target_user_id */
  target_organization_id?: string | null;
  /** User ID to own the new template (can differ from conversion user) */
  target_user_id: string;
  /** Title for the new template */
  title: string;
};
export type SaveConvertedRevisionResponse = {
  /** Human-readable result message */
  message: string;
  /** Version number of the new revision */
  new_version: number;
  /** Whether the save was successful */
  success: boolean;
  /** Template UUID */
  template_id: string;
};
export type SaveConvertedRevisionRequest = {
  /** Template content */
  content?: string;
  /** Revision description */
  description?: string | null;
  /** Revision metadata */
  metadata?: {
    [key: string]: any;
  };
  /** List of model IDs */
  models?: any[];
  /** Template UUID to create revision on */
  note_template_id: string;
  /** List of section objects with converted prompts */
  sections: any[];
  /** User ID who will own/create the revision (can differ from conversion user) */
  target_user_id: string;
  /** Revision title */
  title: string;
};
export type StartModelConversionResponse = {
  /** Initial status */
  status: string;
  /** Celery task ID */
  task_id: string;
  /** Thread ID for polling status */
  thread_id: string;
};
export type StartModelConversionRequest = {
  /** Max examples to validate per section */
  max_validation_examples?: number;
  /** Note template UUID (new format) */
  note_template_id: string;
  /** Number of validation runs per example */
  runs_per_example?: number;
  /** Skip validation phase (faster) */
  skip_validation?: boolean;
  /** Target model to optimize for */
  target_model?: string;
  /** User ID to find example notes for */
  user_id: string;
};
export type ModelConversionStatusResponse = {
  conversion_results?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Current phase */
  current_phase?: string;
  /** Current step */
  current_step?: string;
  error?: string | null;
  /** Legacy template ID (if available) */
  legacy_template_id?: string | null;
  /** Note template UUID */
  note_template_id?: string | null;
  /** Human-readable progress */
  progress_message?: string;
  /** Progress percentage (0-100) */
  progress_percent?: number;
  proposed_revision?: {
    [key: string]: any;
  } | null;
  /** Sections converted */
  sections_converted?: number | null;
  /** Total sections */
  sections_total?: number | null;
  /** Workflow status */
  status: string;
  validation_results?:
    | {
        [key: string]: any;
      }[]
    | null;
};
export type AdminCreateOrgTemplateRequest = {
  /** Template content */
  content: string;
  /** Template description */
  description?: string | null;
  /** Template metadata */
  metadata?: {
    [key: string]: any;
  };
  /** Template prompt */
  prompt?: string | null;
  /** Template title */
  title: string;
};
export type TemplatePermissions = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type NoteTemplateRevisionSummary = {
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  published_at?: string | null;
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope3 = "public" | "org" | "user";
export type NoteTemplate3 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope3;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type EffectiveNoteTemplateSummary = {
  display_order?: number | null;
  permissions?: TemplatePermissions | null;
  revision: NoteTemplateRevisionSummary;
  template: NoteTemplate3;
};
export type AdminProviderTemplateListResponse = {
  /** Templates visible to the provider in their picker */
  templates?: EffectiveNoteTemplateSummary[];
};
export type AdminDeleteTemplateResponse = {
  /** Status message */
  message: string;
  /** Whether deletion was successful */
  success: boolean;
};
export type ExtractionPrompts3 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection3 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts3 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision3 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection3[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope4 = "public" | "org" | "user";
export type NoteTemplate4 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope4;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminGetNoteTemplateResponse = {
  revision: NoteTemplateRevision3;
  template: NoteTemplate4;
};
export type ExtractionPrompts4 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection4 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts4 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision4 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection4[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope5 = "public" | "org" | "user";
export type NoteTemplate5 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope5;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type AdminUpdateNoteTemplateResponse = {
  message?: string;
  revision: NoteTemplateRevision4;
  template: NoteTemplate5;
};
export type AdminNoteTemplateSectionRequest = {
  /** Generation prompt content */
  content: string;
  /** Example generated output */
  example_output?: string | null;
  /** Section ID (stable, hyphenated) */
  id: string;
  /** Legacy module ID for migration */
  legacy_module_id?: string | null;
  /** Display order */
  order?: number;
  /** Section display title */
  title: string;
};
export type AdminUpdateNoteTemplateRequest = {
  /** Whether users can fork this template */
  allow_user_forks?: boolean | null;
  /** Template description */
  description?: string | null;
  /** List of LLM models for note generation. When null/omitted, defaults to ['gpt-5-mini', 'claude-4-5-sonnet'] */
  models?: string[] | null;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number | null;
  /** Organization ID (required for org/user scope) */
  organization_id?: string | null;
  /** Owner scope: public, org, or user */
  owner_scope?: string | null;
  /** Global prompt/instructions */
  prompt?: string | null;
  /** Template sections */
  sections?: AdminNoteTemplateSectionRequest[] | null;
  /** Whether template is sharable via link */
  sharable?: boolean | null;
  /** Template title */
  title?: string | null;
  /** User ID who owns the template */
  user_id?: string | null;
};
export type AdminRevisionSummary = {
  /** When this revision was created */
  created_at: string;
  /** User ID who created this revision */
  created_by: string;
  /** Whether this is a draft revision */
  draft?: boolean;
  /** Number of sections in this revision */
  section_count: number;
  /** Revision title */
  title: string;
  /** Revision version number */
  version: number;
};
export type AdminListRevisionsResponse = {
  /** List of revision summaries */
  revisions?: AdminRevisionSummary[];
};
export type ExtractionPrompts5 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection5 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts5 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type AdminGetRevisionResponse = {
  /** When this revision was created */
  created_at: string;
  /** User ID who created this revision */
  created_by: string;
  /** Revision description */
  description?: string | null;
  /** LLM models for generation */
  models?: string[] | null;
  /** Global prompt/instructions */
  prompt?: string | null;
  /** Template sections */
  sections?: NoteTemplateSection5[];
  /** Revision title */
  title: string;
  /** Revision version number */
  version: number;
};
export type AsyncTaskStatusResponse = {
  /** Task result data when completed */
  data?: {
    [key: string]: any;
  } | null;
  /** Task status (pending, completed, error) */
  status: string;
};
export type ExtractionPrompts6 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection6 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts6 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision5 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection6[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope6 = "public" | "org" | "user";
export type NoteTemplate6 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope6;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type ConvertLegacyTemplateResponse = {
  revision: NoteTemplateRevision5;
  template: NoteTemplate6;
};
export type ConvertLegacyTemplateRequest = {
  /** Organization ID (required for user-scoped templates) */
  organization_id?: string | null;
  /** The legacy template ID (e.g., p:uuid for public, u:uuid for user) */
  template_id: string;
  /** User ID for the converted template */
  user_id: string;
};
export type TemplateErrorInfo = {
  /** The error message */
  error: string;
  /** The template name */
  name: string;
  /** The template ID that failed to copy */
  template_id: string;
};
export type CopiedTemplateInfo = {
  /** The template name */
  name: string;
  /** The newly created template ID */
  new_id: string;
  /** The original template ID */
  original_id: string;
};
export type CopyTemplatesResponse = {
  /** List of any errors encountered during copying */
  errors?: TemplateErrorInfo[];
  /** Number of public templates skipped */
  skipped_public?: number;
  /** List of successfully copied templates with their old and new IDs */
  templates?: CopiedTemplateInfo[];
  /** Number of user templates successfully copied */
  total_copied?: number;
};
export type CopyTemplatesRequest = {
  /** The ID of the user to copy templates from */
  source_user_id: string;
  /** The ID of the user to copy templates to */
  target_user_id: string;
};
export type SingleModuleGenerationResponse = {
  /** Task ID for the async generation */
  task_id: string;
};
export type SingleModuleGenerationRequest = {
  /** Async task ID for tracking */
  async_task_id: string;
  /** Note processing session ID */
  note_processing_session_id?: string | null;
  /** Processing module configuration */
  processing_module: {
    [key: string]: any;
  };
  /** Selected note ID */
  selected_note_id?: string | null;
};
export type UserTemplateInfo = {
  /** User ID of template creator */
  created_by: string;
  /** Creation timestamp */
  created_on?: number | null;
  /** Name of template creator */
  creator_name?: string | null;
  /** Display name if different from template name */
  display_name?: string | null;
  /** Last modification timestamp */
  modified_on?: number | null;
  /** Number of sections in template */
  sections_count?: number;
  /** Unique template ID */
  template_id: string;
  /** Template name */
  template_name: string;
};
export type UserTemplateListResponse = {
  /** List of user templates */
  templates?: UserTemplateInfo[];
  /** Total number of templates matching criteria */
  total_count?: number;
};
export type TemplatePermissions2 = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type NoteTemplateRevisionSummary2 = {
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  published_at?: string | null;
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope7 = "public" | "org" | "user";
export type NoteTemplate7 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope7;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type EffectiveNoteTemplateSummary2 = {
  display_order?: number | null;
  permissions?: TemplatePermissions2 | null;
  revision: NoteTemplateRevisionSummary2;
  template: NoteTemplate7;
};
export type NoteTemplateListResponse = {
  templates: EffectiveNoteTemplateSummary2[];
};
export type TemplatePermissions3 = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type ExtractionPrompts7 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type NoteTemplateSection7 = {
  content: string;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts7 | null;
  id: string;
  legacy_module_id?: string | null;
  order?: number;
  title: string;
};
export type NoteTemplateRevision6 = {
  content: string;
  created_at: string;
  created_by: string;
  description?: string | null;
  draft?: boolean;
  metadata?: {
    [key: string]: any;
  };
  models?: string[] | null;
  prompt?: string | null;
  published_at?: string | null;
  sections?: NoteTemplateSection7[];
  template_id: string;
  title: string;
  updated_at: string;
  version: number;
};
export type NoteTemplateOwnerScope8 = "public" | "org" | "user";
export type NoteTemplate8 = {
  allow_user_forks?: boolean;
  created_at: string;
  current_version: number;
  deleted_at?: string | null;
  id: string;
  note_processing_version?: number;
  organization_id?: string | null;
  owner_scope: NoteTemplateOwnerScope8;
  parent_template_id?: string | null;
  sharable?: boolean;
  updated_at: string;
  user_id: string;
};
export type EffectiveNoteTemplateResponse = {
  display_order?: number | null;
  permissions: TemplatePermissions3;
  revision: NoteTemplateRevision6;
  template: NoteTemplate8;
};
export type NoteTemplateSectionRequest = {
  content: string;
  /** Preview of what this section generates */
  example_output?: string | null;
  id: string;
  order?: number;
  title: string;
};
export type CreateNoteTemplateRequest = {
  description?: string | null;
  prompt?: string | null;
  sections?: NoteTemplateSectionRequest[];
  title: string;
};
export type DraftSectionResponse = {
  content: string;
  example_output?: string | null;
  id: string;
  order: number;
  title: string;
};
export type DraftTemplateResponse = {
  description?: string | null;
  sections: DraftSectionResponse[];
  title: string;
};
export type TemplateBuildUploadResponse = {
  draft_template?: DraftTemplateResponse | null;
  source_template_id?: string | null;
  status: string;
  task_id: string;
  thread_id: string;
};
export type TemplateBuildFromTemplateRequest = {
  /** ID of the existing template to load for editing */
  template_id: string;
};
export type DraftSectionResponse2 = {
  content: string;
  example_output?: string | null;
  id: string;
  order: number;
  title: string;
};
export type DraftTemplateResponse2 = {
  description?: string | null;
  sections: DraftSectionResponse2[];
  title: string;
};
export type TemplateBuildStatusResponse = {
  created_template_id?: string | null;
  document_summary?: string | null;
  document_title?: string | null;
  draft_template?: DraftTemplateResponse2 | null;
  error?: string | null;
  progress_message?: string | null;
  source_template_id?: string | null;
  status: string;
  task_id: string;
};
export type TemplateBuildConfirmRequest = {
  action?: string;
  confirmed?: boolean;
};
export type TemplateBuildSaveResponse = {
  status?: string;
  task_id: string;
  template_id: string;
};
export type OrgNoteTemplateInfo = {
  /** Whether users can fork this */
  allow_user_forks: boolean;
  /** Creation timestamp */
  created_at?: string | null;
  /** Current published version */
  current_version: number;
  /** Template description */
  description?: string | null;
  /** Template UUID */
  id: string;
  /** Processing version: 1 for v1 flow, 2 for v2 flow */
  note_processing_version?: number;
  /** Organization ID */
  organization_id?: string | null;
  /** Owner scope (public, org, user) */
  owner_scope: string;
  /** Template title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** User ID who owns the template */
  user_id: string;
};
export type OrgNoteTemplateListResponse = {
  /** List of templates */
  templates?: OrgNoteTemplateInfo[];
  /** Total number of templates */
  total_count?: number;
};
export type NoteTemplateSectionRequest2 = {
  content: string;
  /** Preview of what this section generates */
  example_output?: string | null;
  id: string;
  order?: number;
  title: string;
};
export type CreateOrgNoteTemplateRequest = {
  /** Whether users can fork this template */
  allow_user_forks?: boolean;
  /** Template description */
  description?: string | null;
  /** Template prompt */
  prompt?: string | null;
  /** Template sections */
  sections?: NoteTemplateSectionRequest2[];
  /** Template title */
  title: string;
};
export type ConvertToOrgTemplateRequest = {
  /** Template UUID to convert */
  template_id: string;
};
export type TemplateOrderItem = {
  display_order?: number | null;
  template_id: string;
};
export type ReorderTemplatesRequest = {
  template_orders: TemplateOrderItem[];
};
export type NoteTemplateSectionRequest3 = {
  content: string;
  /** Preview of what this section generates */
  example_output?: string | null;
  id: string;
  order?: number;
  title: string;
};
export type UpdateNoteTemplateRequest = {
  allow_user_forks?: boolean | null;
  description?: string | null;
  prompt?: string | null;
  sections?: NoteTemplateSectionRequest3[] | null;
  title?: string | null;
};
export type UpdateSectionContentRequest = {
  content: string;
};
export type SectionLibraryPermissions = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type ExtractionPrompts8 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type SectionLibraryOwnerScope = "public" | "org" | "user";
export type SectionLibraryItem = {
  allow_user_forks?: boolean;
  categories?: string[];
  content: string;
  created_at: string;
  deleted_at?: string | null;
  description?: string | null;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts8 | null;
  id: string;
  legacy_module_id?: string | null;
  organization_id?: string | null;
  owner_scope: SectionLibraryOwnerScope;
  parent_section_id?: string | null;
  title: string;
  updated_at: string;
  user_id: string;
};
export type SectionLibraryResponse = {
  permissions: SectionLibraryPermissions;
  section: SectionLibraryItem;
};
export type SectionLibraryListResponse = {
  sections: SectionLibraryResponse[];
  total: number;
};
export type SearchSectionsRequest = {
  /** Categories to filter by */
  categories?: string[] | null;
  /** Text search query */
  query: string;
};
export type SectionLibraryPermissions2 = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type ExtractionPrompts9 = {
  keyword_prompt: string;
  semantic_prompt: string;
};
export type SectionLibraryOwnerScope2 = "public" | "org" | "user";
export type SectionLibraryItem2 = {
  allow_user_forks?: boolean;
  categories?: string[];
  content: string;
  created_at: string;
  deleted_at?: string | null;
  description?: string | null;
  example_output?: string | null;
  extraction_prompts?: ExtractionPrompts9 | null;
  id: string;
  legacy_module_id?: string | null;
  organization_id?: string | null;
  owner_scope: SectionLibraryOwnerScope2;
  parent_section_id?: string | null;
  title: string;
  updated_at: string;
  user_id: string;
};
export type SectionLibraryResponse2 = {
  permissions: SectionLibraryPermissions2;
  section: SectionLibraryItem2;
};
export type ForkSectionRequest = {
  description?: string | null;
  title?: string | null;
};
